package com.karawek.core.ui.components

import androidx.compose.material3.Checkbox
import androidx.compose.material3.CheckboxDefaults
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import com.karawek.core.ui.theme.CoreAlphas
import com.karawek.core.ui.theme.CoreTheme

@Composable
fun CoreCheckbox(
    checked: Boolean,
    onCheckedChange: (Boolean) -> Unit,
    enabled: Boolean = true,
    modifier: Modifier = Modifier,
) {
    Checkbox(
        checked = checked,
        onCheckedChange = if (enabled) onCheckedChange else null,
        enabled = enabled,
        modifier = modifier,
        colors = CheckboxDefaults.colors(
            checkedColor = CoreTheme.colors.primary,
            uncheckedColor = CoreTheme.colors.divider,
            checkmarkColor = CoreTheme.colors.onPrimary,
            disabledCheckedColor = CoreTheme.colors.primary.copy(alpha = CoreAlphas.Disabled),
            disabledUncheckedColor = CoreTheme.colors.divider.copy(alpha = CoreAlphas.Disabled),
        ),
    )
}
